"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5],{

/***/ 6067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ HoneyPot_HoneyPot; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/HoneyPot/HoneyPot.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var HoneyPot = function HoneyPot(_ref) {
  var register = _ref.register,
      _onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "absolute -left-[500px]",
    "aria-hidden": "true",
    style: {
      zIndex: -1
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: "user_code"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
      type: "text",
      id: "user_code",
      name: "user_code",
      autoComplete: "off",
      placeholder: "User Code"
    }, register('user_code', {
      onChange: function onChange(e) {
        return _onChange(e);
      }
    })))]
  });
};

/* harmony default export */ var HoneyPot_HoneyPot = (HoneyPot);
;// CONCATENATED MODULE: ./components/HoneyPot/index.ts


/***/ }),

/***/ 9121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ PDPAConsent_PDPAConsent; },
  "S": function() { return /* reexport */ initialPDPAInfoPayload; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./utils/translate.ts
var translate = __webpack_require__(954);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/PDPAConsent/PDPAConsent.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var PDPAConsent = function PDPAConsent(_ref) {
  var choices = _ref.choices,
      payload = _ref.payload,
      setPayload = _ref.setPayload,
      valid = _ref.valid,
      setValid = _ref.setValid,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$newDesign = _ref.newDesign,
      newDesign = _ref$newDesign === void 0 ? false : _ref$newDesign;

  var _useState = (0,react.useState)({
    'PP-1': false,
    'PP-2': false,
    'PP-3': false,
    'PP-4': false,
    'PP-5': false
  }),
      uiCheckbox = _useState[0],
      setUICheckbox = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showSendBy = _useState2[0],
      setShowSendBy = _useState2[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useState3 = (0,react.useState)(false),
      consent = _useState3[0],
      setConsent = _useState3[1];

  (0,react.useEffect)(function () {
    // update uiCheck when payload updated
    var purposes = payload === null || payload === void 0 ? void 0 : payload.purposes;
    if (!purposes) return;
    var updated = {};
    purposes.forEach(function (p) {
      updated[p.purpose] = p.consented;
    });
    setUICheckbox(_objectSpread(_objectSpread({}, uiCheckbox), updated)); // validate form

    var allFalse = purposes.every(function (p) {
      return !p.consented;
    });

    if (allFalse) {
      setValid(false);
      return;
    }

    var selectSomeSendBy = purposes.filter(function (p) {
      return ['PP-4', 'PP-5'].includes(p.purpose);
    }).some(function (p) {
      return p.consented;
    });
    setValid(selectSomeSendBy);
  }, [payload]);

  var toggleCheckbox = function toggleCheckbox(checkedType, allConsent) {
    var purposes = payload.purposes;
    purposes = purposes.map(function (p) {
      if (p.purpose !== checkedType) return p;

      if (allConsent !== undefined) {
        p.consented = allConsent;
      } else {
        p.consented = !p.consented;
      }

      return p;
    });
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      purposes: purposes
    }));
  };

  var handleSelectChoice = function handleSelectChoice(checkedType) {
    var _payload$purposes, _payload$purposes2;

    toggleCheckbox(checkedType);
    var isCheckedSomeChoices = ((_payload$purposes = payload === null || payload === void 0 ? void 0 : payload.purposes) !== null && _payload$purposes !== void 0 ? _payload$purposes : []).filter(function (p) {
      return choices.includes(p.purpose);
    }).some(function (p) {
      return p.consented;
    });

    if (isCheckedSomeChoices) {
      autoSelectSendByEmail();
      return;
    }

    var noCheckedAnyChoices = ((_payload$purposes2 = payload === null || payload === void 0 ? void 0 : payload.purposes) !== null && _payload$purposes2 !== void 0 ? _payload$purposes2 : []).filter(function (p) {
      return choices.includes(p.purpose);
    }).every(function (p) {
      return !p.consented;
    });

    if (noCheckedAnyChoices) {
      clearAllCheck();
    }
  };

  var handleSelectConsent = function handleSelectConsent(checked) {
    setConsent(checked);
    payload.purposes.forEach(function (p) {
      toggleCheckbox(p.purpose, checked);
    });
  };

  var handleSelectSendBy = function handleSelectSendBy(checkedType) {
    toggleCheckbox(checkedType);
  };

  var autoSelectSendByEmail = function autoSelectSendByEmail() {
    var purposes = payload.purposes;
    var alreadySelectSomeSendBy = purposes.filter(function (p) {
      return ['PP-4', 'PP-5'].includes(p.purpose);
    }).some(function (p) {
      return p.consented;
    });

    if (alreadySelectSomeSendBy) {
      return;
    }

    purposes = purposes.map(function (p) {
      if (p.purpose !== 'PP-4') return p;
      p.consented = true;
      return p;
    });
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      purposes: purposes
    }));
    setShowSendBy(true);
  };

  var clearAllCheck = function clearAllCheck() {
    var purposes = payload.purposes;
    purposes = purposes.map(function (p) {
      p.consented = false;
      return p;
    });
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      purposes: purposes
    }));
    setShowSendBy(false);
  };

  if (newDesign) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        className: "flex mb-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-4 h-4 lg:my-0.5",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "pdpa-consent",
            type: "checkbox",
            checked: consent,
            className: "cursor-pointer",
            onChange: function onChange(e) {
              return handleSelectConsent(e.target.checked);
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "ml-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "pdpa-consent",
            className: "cursor-pointer",
            children: lang === 'en' ? 'I agree to be contacted by CODIUM regarding relevant products or services. See our' : 'ข้าพเจ้ายินยอมให้โคเดียมติดต่อและนำเสนอผลิตภัณฑ์หรือบริการที่เหมาะสม โดยสามารถอ่านเพิ่มเติมได้ที่'
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: '/privacy-policy',
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              className: " text-lightBlue underline cursor-pointer hover:text-lightBlue-600",
              children: (0,translate/* translate2 */.n7)('นโยบายความเป็นส่วนตัว', 'Privacy Policy.', lang)
            })
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-p3Medium",
        children: (0,translate/* translate2 */.n7)('โคเดียมสัญญาว่าจะให้ความคุ้มครองข้อมูลส่วนบุคคลของคุณ', 'At CODIUM, we guarantee the protection of your personal data', lang)
      }), ' ', (0,translate/* translate2 */.n7)('และเราจะใช้ข้อมูลส่วนบุคคลของคุณเท่าที่จำเป็นสำหรับการนำเสนอผลิตภัณฑ์/บริการที่คุณร้องขอมาเท่านั้น', 'and ensure it is used only as necessary to deliver the products and services you have requested.', lang), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), (0,translate/* translate2 */.n7)('ในบางกรณีเราอาจจะติดต่อไปหาคุณเพื่อการนำเสนอผลิตภัณฑ์, บริการหรือกิจกรรมที่ตรงกับความต้องการของคุณ ถ้าหากคุณต้องการให้เราติดต่อไปเพื่อวัตถุประสงค์ดังกล่าว โปรดเลือกให้ความยินยอมกับเราในกรณีต่อไปนี้', 'In certain cases, we may reach out to share products, services, or activities tailored to your needs. If you would like us to contact you for these purposes, please provide your consent in the scenarios outlined below.', lang)]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: choices.map(function (choice) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: mode === 'dark' ? 'flex items-center mb-4' : "px-3 py-4 flex mb-4 rounded-md ".concat(uiCheckbox[choice] ? 'bg-[#D6EBF0]' : 'bg-white'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-4 h-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              id: choice,
              type: "checkbox",
              checked: uiCheckbox[choice],
              onChange: function onChange() {
                return handleSelectChoice(consentPurposeDetail[choice].value);
              },
              className: "cursor-pointer"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "ml-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              htmlFor: choice,
              className: "cursor-pointer",
              children: (0,translate/* translate */.Iu)(consentPurposeDetail[choice], 'label', lang)
            })
          })]
        }, choice);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), showSendBy ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: (0,translate/* translate2 */.n7)('โปรดเลือกช่องทางที่คุณต้องการให้เราติดต่อคุณ', 'Please select your preferred method of contact.', lang)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: mode === 'dark' ? 'flex space-x-28 items-center mb-6' : "flex space-x-28 px-3 py-4 bg-white rounded-md mb-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "byEmail",
            type: "checkbox",
            checked: uiCheckbox['PP-4'],
            onChange: function onChange() {
              return handleSelectSendBy('PP-4');
            },
            className: "cursor-pointer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "byEmail",
            className: "ml-4 cursor-pointer",
            children: (0,translate/* translate2 */.n7)(consentPurposeDetail['PP-4'].labelTH, consentPurposeDetail['PP-4'].label, lang)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "byPhone",
            type: "checkbox",
            checked: uiCheckbox['PP-5'],
            onChange: function onChange() {
              return handleSelectSendBy('PP-5');
            },
            className: "cursor-pointer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "byPhone",
            className: "ml-4 cursor-pointer",
            children: (0,translate/* translate2 */.n7)(consentPurposeDetail['PP-5'].labelTH, consentPurposeDetail['PP-5'].label, lang)
          })]
        })]
      }), !valid ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-red text-p3Regular px-3 -mt-3 mb-6",
        children: (0,translate/* translate2 */.n7)('กรุณาเลือกช่องทางการติดต่อ', 'Please select a contact method', lang)
      }) : null]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: "".concat(mode === 'dark' ? 'text-white' : 'text-neutral-600'),
      children: ["*", ' ', (0,translate/* translate2 */.n7)('คุณสามารถถอนความยินยอมของคุณได้ทุกเมื่อ สำหรับช่องทางการติดต่อเพื่อขอถอนความยินยอม และรายละเอียดการคุ้มครองข้อมูล ส่วนบุคคลของคุณ โปรดอ่านได้ที่', 'You may withdraw your consent at any time. For information on how to request the withdrawal of consent and details about how we manage your personal data, please refer to our', lang), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/privacy-policy',
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          className: " text-lightBlue underline cursor-pointer hover:text-lightBlue-600",
          children: (0,translate/* translate2 */.n7)('ประกาศความเป็นส่วนตัวของเรา', 'Privacy Policy', lang)
        })
      })]
    })]
  });
};

/* harmony default export */ var PDPAConsent_PDPAConsent = (PDPAConsent);
var consentPurposeDetail = {
  'PP-1': {
    label: 'For the purpose of analyzing and presenting products or services that may interest you.',
    labelTH: 'เพื่อการวิเคราะห์และนำเสนอผลิตภัณฑ์บริการที่ฉันอาจสนใจ',
    value: 'PP-1'
  },
  'PP-2': {
    label: 'To invite you to participate in events or seminars that may be of interest to you.',
    labelTH: 'เพื่อการเชิญฉันเข้าร่วมกิจกรรม/งานสัมมนาที่ฉันอาจสนใจ',
    value: 'PP-2'
  },
  'PP-3': {
    label: 'To share interesting updates and new insights from CODIUM..',
    labelTH: 'เพื่อรับข่าวสารความรู้ใหม่ๆ ที่น่าสนใจจากโคเดียม',
    value: 'PP-3'
  },
  'PP-4': {
    label: 'Email',
    labelTH: 'อีเมล',
    value: 'PP-4'
  },
  'PP-5': {
    label: 'Phone Number',
    labelTH: 'โทรศัพท์',
    value: 'PP-5'
  }
};
;// CONCATENATED MODULE: ./components/PDPAConsent/PDPAConsent.utils.ts
var initialPDPAInfoPayload = function initialPDPAInfoPayload(customerCode, note) {
  return {
    customer_code: customerCode,
    purposes: [{
      purpose: 'PP-1',
      consented: false,
      note: note
    }, {
      purpose: 'PP-2',
      consented: false,
      note: note
    }, {
      purpose: 'PP-3',
      consented: false,
      note: note
    }, {
      purpose: 'PP-4',
      consented: false,
      note: note
    }, {
      purpose: 'PP-5',
      consented: false,
      note: note
    }]
  };
};
;// CONCATENATED MODULE: ./components/PDPAConsent/index.ts



/***/ }),

/***/ 8947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var models_conent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3290);
/* harmony import */ var _components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5314);
/* harmony import */ var utils_translate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(954);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);









var SuccessRegistration = function SuccessRegistration(_ref) {
  var showModal = _ref.showModal,
      setShowModal = _ref.setShowModal;

  var _useLocale = (0,_components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .b)(),
      lang = _useLocale.lang;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: showModal ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "relative w-auto my-6 mx-auto max-w-3xl",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "bg-[#e6f9fc] border-0 rounded-lg shadow-lg relative flex flex-col h-auto xl:h-1/4 outline-none focus:outline-none",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
              className: "relative p-6 flex flex-col justify-center justify-self-center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
                className: "ml-auto border-0 mb-10 text-black float-right text-xl md:text-3xl outline-none focus:outline-none",
                onClick: function onClick() {
                  return setShowModal(false);
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
                  className: "text-black -mt-2 h-6 w-6 text-2xl block float-right outline-none focus:outline-none",
                  children: "x"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
                  src: "".concat(models_conent__WEBPACK_IMPORTED_MODULE_4__/* .strapi */ .s1, "/uploads/Group_13916_2x_c5c9fcdc36.png"),
                  className: "h-36 w-36 xl:h-32 xl:w-32 rounded-lg"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                className: "mt-8 xl:mt-4 text-center text-neutral text-4xl md:text-2xl xl:text-lg",
                children: (0,utils_translate__WEBPACK_IMPORTED_MODULE_5__/* .translate2 */ .n7)('ลงทะเบียนสำเร็จ', 'Registration Successful', lang)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("p", {
                className: "text-neutral !leading-8 text-center mx-8 md:mx-4 mb-6 md:mb-4  text-3xl md:text-xl xl:text-base",
                children: [(0,utils_translate__WEBPACK_IMPORTED_MODULE_5__/* .translate2 */ .n7)('ขอบคุณสำหรับข้อมูลค่ะ', 'Thank you for contacting us.', lang), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("br", {}), (0,utils_translate__WEBPACK_IMPORTED_MODULE_5__/* .translate2 */ .n7)('ทางบริษัทจะติดต่อกลับภายใน 1 วันทำการ', 'We will contact you as soon as possible within 1 business day.', lang)]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                className: "flex justify-center w-auto mb-8 md:mb-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                  href: "/blogs",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
                    className: "text-white bg-lightBlue hover:bg-lightBlue-700 font-bold uppercase text-4xl md:text-2xl xl:text-lg outline-none px-6 py-4 xl:py-2 rounded-lg focus:outline-none ease-linear transition-all duration-150 w-auto",
                    type: "button",
                    children: (0,utils_translate__WEBPACK_IMPORTED_MODULE_5__/* .translate2 */ .n7)('อ่านบทความเพิ่มเติม', 'Read more', lang)
                  })
                })
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "opacity-25 fixed inset-0 z-40 bg-black",
        onClick: function onClick() {
          return setShowModal(false);
        }
      })]
    }) : null
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SuccessRegistration);

/***/ }),

/***/ 4425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5314);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var ErrorModal = function ErrorModal(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      children = _ref.children;

  var _useLocale = (0,_components_Contexts_LocaleContext__WEBPACK_IMPORTED_MODULE_0__/* .useLocale */ .b)(),
      lang = _useLocale.lang;

  if (!show) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "bg-white rounded-xl shadow-lg max-w-md w-full p-8 relative animate-fade-in",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
        "aria-label": "Close",
        className: "absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl",
        onClick: onClose,
        children: "\xD7"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "mb-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
            width: "48",
            height: "48",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
              cx: "12",
              cy: "12",
              r: "10",
              fill: "#f87171"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
              d: "M12 7v5m0 4h.01",
              stroke: "#fff",
              strokeWidth: "2",
              strokeLinecap: "round"
            })]
          })
        }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          className: "mt-2 px-6 py-2 rounded bg-blue-600 text-white font-medium hover:bg-blue-700 transition",
          onClick: onClose,
          children: lang === 'en' ? 'Close' : 'ปิด'
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorModal);

/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GTMPageView; }
/* harmony export */ });
var GTMPageView = function GTMPageView(url, event) {
  var pageEvent = {
    event: event,
    page: url
  }; //@ts-ignore

  window && window.dataLayer && window.dataLayer.push(pageEvent);
  return pageEvent;
};

/***/ }),

/***/ 954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ findContent; },
/* harmony export */   "Iu": function() { return /* binding */ translate; },
/* harmony export */   "OC": function() { return /* binding */ filterContent; },
/* harmony export */   "n7": function() { return /* binding */ translate2; },
/* harmony export */   "pF": function() { return /* binding */ findContentByTitle; },
/* harmony export */   "rT": function() { return /* binding */ titleOnly; }
/* harmony export */ });
var translate = function translate(item, name, lang) {
  if (!item) return;
  var translated = lang === 'en' ? item[name] : item["".concat(name, "TH")];
  return translated ? translated : item[name];
};
var titleOnly = function titleOnly(item) {
  if (!item) return;
  var titleItem = JSON.parse(JSON.stringify(item));
  delete titleItem.subContent;
  return titleItem;
};
var findContent = function findContent(data, name) {
  return data === null || data === void 0 ? void 0 : data.find(function (item) {
    return item.name === name;
  });
};
var findContentByTitle = function findContentByTitle(data, name) {
  return data === null || data === void 0 ? void 0 : data.find(function (item) {
    return item.title === name;
  });
};
var filterContent = function filterContent(data, name) {
  return data === null || data === void 0 ? void 0 : data.filter(function (item) {
    return item.name === name;
  });
};
var translate2 = function translate2(th, en, lang) {
  return lang === 'en' ? en : th;
};

/***/ }),

/***/ 1672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jU": function() { return /* binding */ formatRules; },
/* harmony export */   "n0": function() { return /* binding */ requiredRule; }
/* harmony export */ });
/* unused harmony exports EMAIL_PATTERN, PHONE_SEPARATOR_PATTERN, PHONE_PATTERN, isValidEmail, isValidPhone, emailMessage, phoneMessage */
/* harmony import */ var utils_translate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(954);

var EMAIL_PATTERN = /^\S+@\S+\.\S+$/; // Phone numbers are typed in every shape people are used to — 081-234-5678,
// (02) 123 4567, +66 81 234 5678 — so the separators are stripped before the
// digit count is checked. The value itself is never rewritten: what the user
// typed is what gets stored.

var PHONE_SEPARATOR_PATTERN = /[\s\-.()]/g;
var PHONE_PATTERN = /^\+?\d{9,15}$/;
var isValidEmail = function isValidEmail(value) {
  return EMAIL_PATTERN.test(String(value !== null && value !== void 0 ? value : '').trim());
};
var isValidPhone = function isValidPhone(value) {
  return PHONE_PATTERN.test(String(value !== null && value !== void 0 ? value : '').replace(PHONE_SEPARATOR_PATTERN, ''));
};
var emailMessage = function emailMessage(lang) {
  return (0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('รูปแบบของ Email ไม่ถูกต้อง กรุณากรอก Email ให้ถูกต้อง', 'Invalid email format. Please enter a valid email.', lang);
};
var phoneMessage = function phoneMessage(lang) {
  return (0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('รูปแบบของหมายเลขโทรศัพท์ไม่ถูกต้อง กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง', 'Invalid phone number format. Please enter a valid phone number.', lang);
};
var EMAIL_FIELDS = ['email'];
var PHONE_FIELDS = ['phone', 'phoneNumber', 'tel'];
/**
 * react-hook-form rules for a field, keyed by its name.
 *
 * Forms are driven by field lists that come from Strapi, so the field name is
 * the only thing available to decide what a value should look like. Returns an
 * empty object for names that need no format check, which makes it safe to
 * spread into every `register()` call.
 *
 * Phone uses `validate` rather than `pattern` because the separators have to be
 * stripped before the digits are counted, which a single regex cannot express.
 */

var formatRules = function formatRules(fieldName, lang) {
  if (EMAIL_FIELDS.includes(fieldName)) {
    return {
      validate: function validate(value) {
        return !value || isValidEmail(value) || emailMessage(lang);
      }
    };
  }

  if (PHONE_FIELDS.includes(fieldName)) {
    return {
      validate: function validate(value) {
        return !value || isValidPhone(value) || phoneMessage(lang);
      }
    };
  }

  return {};
};

/**
 * react-hook-form `required` rule with the message every form uses:
 * "กรุณากรอก <label>" / "Please enter your <label>".
 */
var requiredRule = function requiredRule(required, label, lang) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$possessive = _ref.possessive,
      possessive = _ref$possessive === void 0 ? true : _ref$possessive,
      _ref$lowercase = _ref.lowercase,
      lowercase = _ref$lowercase === void 0 ? true : _ref$lowercase;

  var text = label !== null && label !== void 0 ? label : '';
  return {
    required: {
      value: required,
      message: "".concat((0,utils_translate__WEBPACK_IMPORTED_MODULE_0__/* .translate2 */ .n7)('กรุณากรอก', possessive ? 'Please enter your' : 'Please enter', lang), " ").concat(lowercase ? text.toLowerCase() : text)
    }
  };
};

/***/ }),

/***/ 29:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

}]);